/* unplugin-vue-components disabled */import { render } from "./PdpConsultScreen.vue?vue&type=template&id=0b98917f&scoped=true&ts=true"
import script from "./PdpConsultScreen.vue?vue&type=script&lang=ts"
export * from "./PdpConsultScreen.vue?vue&type=script&lang=ts"

import "./PdpConsultScreen.vue?vue&type=style&index=0&id=0b98917f&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b98917f"]])

export default __exports__